/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

export const phoneNumberNumeric = (phoneNumber: string): string => phoneNumber.replace(/[^0-9]/g, '');
